import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const exportToPDF = (title, columns, data, filename) => {
  const doc = new jsPDF();
  
  // Header
  doc.setFontSize(18);
  doc.setTextColor(28, 25, 23);
  doc.text(title, 14, 22);
  
  // Date
  doc.setFontSize(10);
  doc.setTextColor(87, 83, 78);
  doc.text(`Gegenereerd op: ${new Date().toLocaleDateString('nl-NL')}`, 14, 30);
  
  // Table
  doc.autoTable({
    startY: 40,
    head: [columns.map(col => col.header)],
    body: data.map(row => columns.map(col => row[col.key] ?? '')),
    headStyles: {
      fillColor: [194, 65, 12],
      textColor: [255, 255, 255],
      fontStyle: 'bold'
    },
    alternateRowStyles: {
      fillColor: [253, 251, 247]
    },
    styles: {
      fontSize: 9,
      cellPadding: 4
    }
  });
  
  doc.save(`${filename}.pdf`);
};

export const exportToExcel = (title, columns, data, filename) => {
  const worksheetData = [
    columns.map(col => col.header),
    ...data.map(row => columns.map(col => row[col.key] ?? ''))
  ];
  
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, title.substring(0, 31));
  
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, `${filename}.xlsx`);
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR'
  }).format(value || 0);
};

export const formatPercentage = (value, decimals = 1) => {
  if (value === null || value === undefined || isNaN(value)) return '0%';
  return `${Number(value).toFixed(decimals)}%`;
};

export const formatNumber = (value) => {
  return new Intl.NumberFormat('nl-NL').format(value || 0);
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('nl-NL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const getWeekNumber = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
};

export const getStartOfWeek = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(d.setDate(diff)).toISOString().split('T')[0];
};

export const getEndOfWeek = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? 0 : 7);
  return new Date(d.setDate(diff)).toISOString().split('T')[0];
};

export const getStartOfMonth = (date) => {
  const d = new Date(date);
  return new Date(d.getFullYear(), d.getMonth(), 1).toISOString().split('T')[0];
};

export const getEndOfMonth = (date) => {
  const d = new Date(date);
  return new Date(d.getFullYear(), d.getMonth() + 1, 0).toISOString().split('T')[0];
};

export const calculateTrend = (current, previous) => {
  if (!previous || previous === 0) return { value: 0, direction: 'neutral' };
  const change = ((current - previous) / previous) * 100;
  return {
    value: Math.abs(change),
    direction: change > 0 ? 'up' : change < 0 ? 'down' : 'neutral'
  };
};

export const getStatusColor = (actual, target, inverted = false) => {
  const ratio = actual / target;
  if (inverted) {
    if (ratio <= 0.9) return 'green';
    if (ratio <= 1.1) return 'orange';
    return 'red';
  } else {
    if (ratio >= 1) return 'green';
    if (ratio >= 0.8) return 'orange';
    return 'red';
  }
};

export const periodOptions = [
  { value: 'dag', label: 'Per dag' },
  { value: 'week', label: 'Per week' },
  { value: 'maand', label: 'Per maand' },
  { value: 'kwartaal', label: 'Per kwartaal' },
  { value: 'jaar', label: 'Per jaar' }
];

export const dayPartOptions = [
  { value: 'ochtend', label: 'Ochtend' },
  { value: 'middag', label: 'Middag' },
  { value: 'avond', label: 'Avond' }
];
